import LanguageIcon from 'shared/ui/LanguageIcon';
import { langs } from 'shared/forms/LanguageSelector';

interface LocaleBadgeProps {
  locale?: string;
  fallbackLocale?: string;
}

const LocaleBadge = ({ locale, fallbackLocale = 'sv-SE' }: LocaleBadgeProps) => {
  const inherited = !locale;
  const resolvedLocale = locale || fallbackLocale || 'sv-SE';
  const langEntry = langs.find((l) => l.locale === resolvedLocale);
  const langCode = langEntry?.lang || resolvedLocale.split('-')[0];
  const label = langCode.toUpperCase();

  return (
    <span
      className={`badge d-inline-flex align-items-center rounded-pill ${
        inherited ? 'bg-gray-100 text-gray-500 border border-gray-300' : 'bg-blue-100 text-blue-700'
      }`}
      title={inherited ? `Inherited from document (${resolvedLocale})` : resolvedLocale}
    >
      <LanguageIcon language={langCode} size={14} className="me-1" />
      {label}
      {inherited && <i className="fa-regular fa-arrow-turn-down-left ms-1" style={{ fontSize: '0.65rem' }} />}
    </span>
  );
};

export default LocaleBadge;
